<template>
	<vs-prompt
		:active.sync="activeData"
		:title="$t('addTask')"
		:acceptText="$t('save')"
		:cancelText="$t('cancel')"
		@cancel="dateData = ''"
		@accept="$emit('create-task')"
	>
		<div class="con-task-prompt">
			<vx-input-group class="mb-4">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">
						{{ $t("chooseDate") }}
					</label>

					<div class="vs-con-input"></div>

					<vs-datepicker
						v-model="dateData"
						v-validate="'required'"
						:key="'activePromptDate'"
						format="dd.MM.yyyy"
						type="datetime"
						name="date"
					></vs-datepicker>
					<span v-if="errors.first('date')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</div>
			</vx-input-group>

			<div
				class="vs-component vs-con-input-label vs-input vs-input-primary  w-full"
			>
				<label class="vs-input--label">
					{{ $t("description") }}
				</label>
				<div class="vs-con-input"></div>
				<vs-textarea
					v-model="aboutData"
					v-validate="'required|min:3|max:300'"
					:key="'activePromptAbout'"
					name="about"
					rows="4"
					class="mb-0"
				/>
				<span v-if="errors.first('about')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
	name: "CreateOrderTask",

	components: {
		Datepicker,
	},

	props: {
		active: { required: true, type: Boolean },
		date: { type: Date, default: null },
		about: { type: String, default: '' },
	},

	data() {
		return {};
	},

	computed: {
		aboutData: {
			get() {
				return this.about
			},
			set(val) {
				this.$emit('update:about', val)
			}
		},

		dateData: {
			get() {
				return this.date
			},
			set(val) {
				this.$emit('update:date', val)
			}
		},

		activeData: {
			get() {
				return this.active
			},
			set(val) {
				this.$emit('update:active', val)
			}
		},
	}
};
</script>

<style lang="scss" scoped>
.con-task-prompt {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}
</style>
